(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/racing-game/components/play/assets/javascripts/pickers/xperten-picker.js') >= 0) return;  svs.modules.push('/modules/racing-game/components/play/assets/javascripts/pickers/xperten-picker.js');

'use strict';

const {
  useState,
  useEffect
} = React;
const RadioGroup = svs.ui.form.RadioGroup;
const RadioButton = svs.ui.form.RadioButton;
const Button = svs.ui.ReactButton;
const {
  useMediaQuery,
  breakpoints,
  BREAKPOINT_LG
} = svs.components.lbUtils.useMediaQuery;
const XpertPicker = _ref => {
  let {
    xpertData,
    selectedSystemSize,
    setSelectedSystemSize,
    isMultipleLines,
    numActiveParticipants,
    isAllCustomPicks
  } = _ref;
  const [displayMore, setDisplayMore] = useState(false);
  const [restoreSelected, setRestoreSelected] = useState(false);
  const onClickHandler = () => displayMore ? setDisplayMore(false) : setDisplayMore(true);
  const maxRowLength = xpertData.length > 9;
  const more = xpertData && maxRowLength;
  const isWideMode = useMediaQuery(breakpoints.up(BREAKPOINT_LG));
  const pixRowWidth = maxRowLength ? 183 : 100;
  useEffect(() => {
    if (isAllCustomPicks && selectedSystemSize === 1) {
      setSelectedSystemSize(0);
      setRestoreSelected(true);
    }
    if (!isAllCustomPicks && restoreSelected && selectedSystemSize === 0) {
      setSelectedSystemSize(1);
      setRestoreSelected(false);
    }
  }, [isAllCustomPicks]);
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "form-toggle-racing"
  }, React.createElement(RadioGroup, {
    multipleLines: isMultipleLines,
    size: "200",
    thin: true,
    transparent: false
  }, xpertData.map(data => !displayMore && data.more && data.systemSize !== selectedSystemSize ? '' : React.createElement(RadioButton, {
    branding: "racing",
    checked: data.systemSize === selectedSystemSize,
    className: "padding-xs-v-1",
    disabled: data.minParticipants > numActiveParticipants || data.disabled,
    key: "xpert-value-".concat(data.amount),
    minWidth: isMultipleLines && !isWideMode ? '33.33%' : "".concat(pixRowWidth / xpertData.length, "%"),
    name: "toggle-radio-group-xpert-value",
    onChange: setSelectedSystemSize,
    value: data.systemSize
  }, data.amount, ' ', "kr")))), more && React.createElement("div", {
    className: "padding-xs-top-1 padding-xs-h-1 u-flex u-flex-justify-content-center"
  }, React.createElement(Button, {
    className: "coupon-display-more f-400",
    onClick: onClickHandler
  }, displayMore ? 'Visa färre' : 'Visa alla')));
};
XpertPicker.defaultProps = {
  isAllCustomPicks: false
};
svs.racing_game.components.play.XpertPicker = XpertPicker;

 })(window);